import type { AIProvider } from "../../types";
import { listModels, streamChat, generateTitle } from "./ollamaClient";

/** Ollama implementation of {@link AIProvider}. Thin by design — all the
 * actual HTTP/NDJSON work lives in `ollamaClient`; this file just satisfies
 * the shape the rest of the app depends on. */
export const OllamaProvider: AIProvider = {
  listModels,
  streamChat,
  generateTitle,
};
